module.exports = __webpack_public_path__ + "img/faq-min.84234a81.svg";